import { push } from "connected-react-router";
import PropTypes from "prop-types";
import React, { Component } from "react";
import DocumentTitle from "react-document-title";
import { connect } from "react-redux";

import { routerSelectors } from "../../base/selectors";
import { userSelectors } from "../../nav/selectors";
import { services } from "../../policies/actions";
import ServicesList from "../../policies/components/ServicesList";
import {
  EntityShape,
  ProductShape,
  ServiceDetailsShape,
  ServiceShape
} from "../../policies/proptypes";
import policySelectors from "../../policies/selectors";
import withModal from "../../shared/components/withModal";
import ServiceDetails from "../components/ServiceDetails";
import ServiceEntities from "../components/ServiceEntities";
import ServiceInstructions from "../components/ServiceInstructions";
import ServicesActions from "../components/ServicesActions";
import RemoveService from "./RemoveService";

class Services extends Component {
  state = {
    removeServiceVisible: false,
    serviceInstructions: undefined
  };

  title = "RBAC - Services";

  static getDerivedStateFromProps = (props, state) => {
    if (state.removeServiceVisible && !props.currentService) {
      return { removeServiceVisible: false };
    }
    return null;
  };

  componentDidMount() {
    const { matchedService, setCurrentService } = this.props;
    this.setFilterTermFromQuerystring();
    if (matchedService) {
      setCurrentService(matchedService.$uri);
    }
  }

  componentDidUpdate(prevProps) {
    const { matchedService, setCurrentService } = this.props;
    if (
      matchedService &&
      prevProps.currentService &&
      prevProps.currentService.$uri !== matchedService.$uri
    ) {
      setCurrentService(matchedService.$uri);
    }
  }

  toggleRemoveServiceVisibility = () => {
    const { removeServiceVisible } = this.state;
    this.setState({ removeServiceVisible: !removeServiceVisible });
  };

  setFilterTermFromQuerystring = () => {
    const { search, setServicesFilterTerm } = this.props;
    if (search && search.filter) {
      setServicesFilterTerm(search.filter);
    }
  };

  setServiceInstructions = service => {
    this.setState({ serviceInstructions: service });
  };

  render() {
    const { serviceInstructions, removeServiceVisible } = this.state;
    const {
      currentService,
      entities,
      loading,
      products,
      registerService,
      saving,
      services,
      canEditServices,
      parentUrl
    } = this.props;

    return (
      <div className="l-services">
        <DocumentTitle title={this.title} />
        <ServicesList
          loading={loading}
          products={products}
          productsSelectable={false}
          services={services}
          currentService={currentService}
          hasFilter
          canEdit={canEditServices}
        />
        <ServiceDetails
          service={currentService}
          openInstructions={
            canEditServices ? this.setServiceInstructions : undefined
          }
        />
        {currentService && (
          <ServiceEntities entities={entities} parentUrl={parentUrl} />
        )}
        <ServicesActions
          disabled={!currentService || removeServiceVisible}
          removeService={
            canEditServices ? this.toggleRemoveServiceVisibility : undefined
          }
          parentUrl={parentUrl}
        />
        {removeServiceVisible && (
          <RemoveService
            service={currentService}
            cancel={this.toggleRemoveServiceVisibility}
          />
        )}
        {serviceInstructions && (
          <ServiceInstructions
            service={currentService}
            registerService={registerService}
            saving={saving}
            closeInstructions={() => this.setServiceInstructions()}
          />
        )}
      </div>
    );
  }
}

Services.propTypes = {
  parentUrl: PropTypes.string.isRequired,
  search: PropTypes.objectOf(PropTypes.string).isRequired,
  currentService: ServiceDetailsShape,
  matchedService: ServiceShape,
  entities: PropTypes.arrayOf(EntityShape).isRequired,
  loading: PropTypes.bool.isRequired,
  products: PropTypes.arrayOf(ProductShape).isRequired,
  registerService: PropTypes.func.isRequired,
  saving: PropTypes.bool,
  services: PropTypes.arrayOf(ServiceShape).isRequired,
  canEditServices: PropTypes.bool.isRequired,
  setServicesFilterTerm: PropTypes.func.isRequired,
  setCurrentService: PropTypes.func.isRequired
};

Services.defaultProps = {
  currentService: undefined,
  matchedService: undefined,
  saving: undefined
};

const mapStateToProps = (state, props) => ({
  currentService: policySelectors.services.getCurrentWithDetails(state),
  matchedService: policySelectors.services.getMatched(state, props),
  entities: policySelectors.entities.getUsingCurrentService(state),
  loading: state.products.loading || state.services.loading,
  saving: state.services.saving,
  products: policySelectors.products.getFiltered(state),
  services: policySelectors.services.getByFilter(state),
  canEditServices: userSelectors.canEditServices(state),
  search: routerSelectors.getSearch(state)
});

const mapDispatchToProps = {
  setServicesFilterTerm: services.setFilterTerm,
  registerService: services.register,
  setCurrentService: services.setCurrent,
  push
};
export default withModal(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Services)
);
